// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"07f3c22d","306":"7e212285","813":"11607dda","838":"474904cc","974":"bbc62581"}[chunkId] + ".chunk.js";
};